// Date 2023-08-02 11:26:04

import sithMomMainProjectTemplateList from "@/views/sithMesII/plan/SithMomMainProjectTemplateList.vue";
import sithMomMainProjectTemplateEdit from "@/views/sithMesII/plan/SithMomMainProjectTemplateEdit.vue";
import sithMomMainProjectPlanList from "@/views/sithMesII/plan/SithMomMainProjectPlanList.vue";
import sithMomMainProjectPlanEdit from "@/views/sithMesII/plan/SithMomMainProjectPlanEdit.vue";
import sithMomMainProjectPlanDetailList from "@/views/sithMesII/plan/SithMomMainProjectPlanDetailList.vue";
import sithMomMainProjectPlanDetailEdit from "@/views/sithMesII/plan/SithMomMainProjectPlanDetailEdit.vue";
import sithMomMainProjectPlanScheduledRecordList
    from "@/views/sithMesII/plan/SithMomMainProjectPlanScheduledRecordList.vue";
import sithMomMainProjectPlanScheduledRecordEdit
    from "@/views/sithMesII/plan/SithMomMainProjectPlanScheduledRecordEdit.vue";
import MainProjectPlanAdjust from "@/views/sithMesII/plan/MainProjectPlanAdjust.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
    {
        path: "/sithMesII/plan/sithMomMainProjectTemplateList",
        name: "sithMomMainProjectTemplateList",
        component: sithMomMainProjectTemplateList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/plan/sithMomMainProjectTemplateEdit",
        name: "sithMomMainProjectTemplateEdit",
        component: sithMomMainProjectTemplateEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/plan/sithMomMainProjectPlanList",
        name: "sithMomMainProjectPlanList",
        component: sithMomMainProjectPlanList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/plan/sithMomMainProjectPlanEdit",
        name: "sithMomMainProjectPlanEdit",
        component: sithMomMainProjectPlanEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/plan/sithMomMainProjectPlanDetailList",
        name: "sithMomMainProjectPlanDetailList",
        component: sithMomMainProjectPlanDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/plan/sithMomMainProjectPlanDetailEdit",
        name: "sithMomMainProjectPlanDetailEdit",
        component: sithMomMainProjectPlanDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/plan/sithMomMainProjectPlanScheduledRecordList",
        name: "sithMomMainProjectPlanScheduledRecordList",
        component: sithMomMainProjectPlanScheduledRecordList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/plan/sithMomMainProjectPlanScheduledRecordEdit",
        name: "sithMomMainProjectPlanScheduledRecordEdit",
        component: sithMomMainProjectPlanScheduledRecordEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
//high customized page register
    {
        path: "/mainProjectPlan/adjust",
        name: "mainProjectPlanAdjust",
        component: MainProjectPlanAdjust
    }
]
